// extracted by mini-css-extract-plugin
export var heroSwiper = "heroSwiper-module--hero-swiper--7CQbv";
export var heroSwiperSlide = "heroSwiper-module--hero-swiper-slide--asTxd";